var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7226 39.4151H20.657C19.1944 39.4151 18 38.2328 18 36.7581V20.5235L20.5747 19L22.327 20.4727L24.8106 19L26.7757 20.5601L29 19L31.541 20.5235V32.2485",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.988 27.168H31.5283V37.2841C31.5283 38.4663 32.479 39.417 33.649 39.417C34.8191 39.417 35.7698 38.4663 35.7698 37.2841V33.0426",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7705 29.277V35.3832H39.9998V29.277C39.9998 28.1069 39.0491 27.1562 37.879 27.1562C36.7212 27.1684 35.7705 28.1069 35.7705 29.277Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1592 35.6181H27.9443V36.101H21.1592V35.6181ZM21.1592 32.6523H27.9443V33.1352H21.1592V32.6523Z",
    fill: "#27AE60",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.751 25.9468L24.7503 25.9466C24.2574 25.8047 23.9458 25.66 23.7582 25.5023C23.5773 25.3501 23.5099 25.1845 23.5099 24.9814C23.5099 24.7447 23.6069 24.5465 23.7854 24.4052C23.9659 24.2623 24.2365 24.1726 24.5879 24.1726C24.9572 24.1726 25.1934 24.2722 25.3413 24.4288C25.4907 24.5871 25.5656 24.82 25.5763 25.1185L25.5798 25.2149H25.6763H26.6356H26.7389L26.7355 25.1116C26.7071 24.249 26.2497 23.442 25.3387 23.1529V22.1406V22.0406H25.2387H23.9316H23.8316V22.1406V23.1371C22.9873 23.3671 22.3057 24.0124 22.3057 25.0005C22.3057 25.5977 22.5267 26.052 22.9087 26.3973C23.2868 26.7391 23.8176 26.97 24.4327 27.137L24.4331 27.1371C24.9717 27.2811 25.2794 27.4573 25.4527 27.6413C25.6222 27.8214 25.6716 28.0183 25.6716 28.2289C25.6716 28.3775 25.6232 28.571 25.4708 28.727C25.3197 28.8817 25.0539 29.0123 24.5936 29.0123C24.1613 29.0123 23.8755 28.9023 23.6923 28.7363C23.5092 28.5704 23.4154 28.3364 23.3917 28.0614L23.3838 27.97H23.2921H22.3271H22.2218L22.2273 28.0752C22.2844 29.1748 22.989 29.8115 23.8316 30.0356V31.0379V31.1379H23.9316H25.2443H25.3443V31.0379V30.0562C25.7537 29.9557 26.1248 29.7688 26.4001 29.48C26.6945 29.1711 26.8729 28.752 26.8758 28.2168L26.8758 28.2158C26.8729 27.487 26.5931 26.9893 26.1822 26.6387C25.7763 26.2924 25.2473 26.0938 24.751 25.9468Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFee);
export default __webpack_public_path__ + "static/media/fee.aa61c6b914c4f92d9366bffef0977898.svg";
export { ForwardRef as ReactComponent };